module.exports = __webpack_public_path__ + "img/order-fail.3c8f3e73.svg";